import {
  Activity,
  BadgeDollarSign,
  Banknote,
  BookOpen,
  CalendarDays,
  ClipboardList,
  FileSpreadsheet,
  Landmark,
  LayoutDashboard,
  LogIn,
  MonitorSmartphone,
  PiggyBank,
  ShieldCheck,
  Users,
  Users2,
  Wallet,
  type LucideIcon,
} from 'lucide-react'
import type { NavIcon } from '@/lib/nav'

// Kept out of nav.ts so the config stays loadable by node --test without React.
export const NAV_ICONS = {
  dashboard: LayoutDashboard,
  agreements: ClipboardList, // applications to review
  funds: Wallet, // client money in and out
  bca: FileSpreadsheet, // CSV import
  accounts: MonitorSmartphone, // MT5 terminals
  clientBanks: Banknote,
  companyBanks: Landmark,
  rates: BadgeDollarSign,
  accsum: BookOpen,
  mtUsers: Users2,
  firstDeposits: PiggyBank,
  daily: CalendarDays,
  loginState: LogIn,
  activity: Activity,
  ekyc: ShieldCheck, // identity checks
  users: Users,
} satisfies Record<NavIcon, LucideIcon>
